import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { buildThumbImage } from '../../utils/utils';
import { RobinAvatar } from './RobinAvatar';
import { useConfig } from '../../context/ConfigContext';
/**
 * Right-side summary for the collapsed People section: a capped avatar stack
 * (first 3 invitees + "+N" overflow), matching Figma states D/E.
 */
export var InviteeAvatarStack = function (_a) {
    var invitees = _a.invitees;
    var environmentUrls = useConfig().environmentUrls;
    var imageServerUrl = environmentUrls.imageServerUrl;
    return (_jsx(Avatar.Group, { max: { count: 3 }, children: invitees.map(function (invitee) {
            var _a;
            return (_jsx(RobinAvatar, { src: buildThumbImage(invitee.avatar, imageServerUrl), name: (_a = invitee.name) !== null && _a !== void 0 ? _a : '', size: 32, icon: _jsx(FontAwesomeIcon, { icon: faUser, size: "sm" }) }, invitee.user_id || invitee.email));
        }) }));
};
